export default "__VITE_ASSET__V3KGM2qY__"